import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const STORE: AppRouteRecordRaw = {
  path: '/store',
  name: 'Store',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.store',
    requiresAuth: true,
    icon: 'icon-home',
    order: 1,
  },
  children: [
    {
      path: 'management',
      name: 'StoreManagement',
      component: () => import('@/views/store/management/index.vue'),
      meta: {
        locale: 'menu.store.management',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'backup',
      name: 'BackupStoreManagement',
      component: () => import('@/views/store/backup/index.vue'),
      meta: {
        locale: 'menu.store.backup',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'archive',
      name: 'ArchiveStoreManagement',
      component: () => import('@/views/store/archive/index.vue'),
      meta: {
        locale: 'menu.store.archive',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default STORE;
